/**
 * @file index.tsx
 *
 * @fileoverview Shows a flat banner to use on landing pages.
 */

import React from "react";
import { ColorsProps, generateColorClasses } from "../../../../theme/colors";
import styles from "./flatBanner.module.scss";

export type FlatBannerProps = ColorsProps & {
  /**
   * The content to show inside the banner.
   */
  children: React.ReactNode;
  /**
   * The banner style (background color)
   */
  flatbannerStyle?: "primary" | "secondary" | "default";
  /**
   * The current theme.
   */
  theme?: any;
};

/**
 * This component provides a text with backgroud color.
 */
export const FlatBanner = ({
  children,
  flatbannerStyle = "primary",
  color,
  backgroundColor,
  ...props
}: FlatBannerProps) => {
  return (
    <div
      className={`
        ${styles.flatBanner}
        ${generateColorClasses({ color, backgroundColor }, styles)}
      `.trim()}
      {...(!color &&
        !backgroundColor && {
          style: {
            backgroundColor: `var(--flat-banner-bg-${flatbannerStyle})`,
          },
        })}
      {...props}
    >
      <div className={styles.flatBannerText}>{children}</div>
    </div>
  );
};

export default FlatBanner;
